import { Slide, Stack, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useBizTypeTranslation } from "hooks/useBizTypeTranslation";
import { useLocation, useNavigate } from "react-router-dom";
import { MENU_PAGES } from "../config/menuPages";
import { useEffect, useState } from "react";
import useLogOut from "../hooks/useLogOut";
import { useSelector } from "react-redux";
import { getCookie } from "../config/functions";
import NullCheck from "./NullCheck";

const CustomPage = ({ header, heightHeader, children, hidePadding, awaitData, title, icon, hideTitle }) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { logOut } = useLogOut();
  const { bt } = useBizTypeTranslation();
  const location = useLocation();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const lang = useSelector((state) => state?.userSettings?.selectedLang);
  const userRole = useSelector((state) => state.userSettings?.user?.userRole);

  const [pageData, setPageData] = useState(null);

  useEffect(() => {
    const token = getCookie("authAnalytics");
    if (!token) logOut();
    const page = findPageByPath(location.pathname)

    if (userRole && page?.showRoles) {
      let roleGroups;
      if (Array.isArray(page.showRoles[0])) roleGroups = page.showRoles;
      else roleGroups = [page.showRoles];
      const allowed = roleGroups.some(group => group.includes(userRole));

      if (allowed) setPageData(page);
      else return navigate("/Error-Page");
    }
    else {
      setPageData(page);
    }
  }, [userRole]);

  const findPageByPath = (path) => {
    for (const page of MENU_PAGES) {
      if (page.path === path) {
        return page;
      }

      if (page.childrens) {
        for (const child of page.childrens) {
          if (child.path === path) {
            return child;
          }
        }
      }
    }
    return null;
  };

  if (awaitData) return;

  return (
    <Stack
      bgcolor="bgPage.main"
      height="100%"
      overflow="hidden"
      borderRadius={isMobile ? 0 : '30px 0px 0px 0px'}
    >
      {/* header */}
      <NullCheck valueForCheck={header}>
        <Stack
          direction="row"
          m={isMobile ? 1 : 2}
          height={heightHeader ? heightHeader : 40}
          alignItems="center"
          justifyContent="space-between"
        >
          <NullCheck valueForCheck={!hideTitle}>
            <Slide direction={lang?.dir === "rtl" ? "left" : "right"} in={true}>
              <Stack height="100%" alignItems="center" direction="row" spacing={1}>
                {icon ? icon : pageData?.icon}
                <Typography variant="h6" color="primary.text">
                  {title ? title : bt(pageData?.title)}
                </Typography>
              </Stack>
            </Slide>
          </NullCheck>

          {header}
        </Stack>
      </NullCheck>

      {/* content */}
      <Stack
        height="100%"
        sx={{ overflowX: "hidden", overflowY: "auto" }}
        direction="row"
        padding={hidePadding || header ? 0 : 2}
        paddingX={hidePadding || isMobile ? 0 : 2}
      >
        {/* <Fade in={true}> */}
        <div style={{ width: "100%" }}>{children}</div>
        {/* </Fade> */}
      </Stack>
    </Stack>
  );
};
export default CustomPage;
